import type { Easing, Transition } from 'framer-motion';

export const QUERY_PANEL_EASE: Easing = [0.16, 1, 0.3, 1];

export const QUERY_PANEL_MOTION_DURATION_S = 0.2;

const presenceTransition: Transition = {
    duration: QUERY_PANEL_MOTION_DURATION_S,
    ease: QUERY_PANEL_EASE,
};

export function queryPanelPresenceTransition(
    prefersReducedMotion: boolean | null,
): Transition {
    if (prefersReducedMotion) {
        return { duration: 0 };
    }
    return presenceTransition;
}

export function queryPanelPresenceProps(prefersReducedMotion: boolean | null) {
    if (prefersReducedMotion) {
        return {
            initial: { opacity: 0 },
            animate: { opacity: 1 },
            exit: { opacity: 0 },
        };
    }
    return {
        initial: { opacity: 0, scale: 0.93 },
        animate: { opacity: 1, scale: 1 },
        exit: { opacity: 0, scale: 0.93 },
    };
}

export const COMPACT_SHELL_CARD_CORNER_RADIUS_PX = 10;
export const COMPACT_SHELL_PILL_CORNER_RADIUS_PX = 9999;

const COMPACT_BORDER_RADIUS_DELAY_FRACTION = 0.6;

const COMPACT_BORDER_RADIUS_DURATION_FRACTION = 0.4;

const BORDER_RADIUS_EASE: Easing = 'easeOut';

export function compactShellLayoutTransition(
    prefersReducedMotion: boolean | null,
): Transition {
    if (prefersReducedMotion) {
        return { duration: 0 };
    }
    return {
        type: 'tween',
        duration: QUERY_PANEL_MOTION_DURATION_S,
        ease: QUERY_PANEL_EASE,
    };
}

export function compactShellBorderRadiusTransition(
    prefersReducedMotion: boolean | null,
    targetIsPill: boolean,
): Transition {
    if (prefersReducedMotion) {
        return { duration: 0 };
    }
    if (!targetIsPill) {
        return {
            type: 'tween',
            duration: QUERY_PANEL_MOTION_DURATION_S * 0.35,
            ease: BORDER_RADIUS_EASE,
        };
    }
    return {
        type: 'tween',
        delay:
            QUERY_PANEL_MOTION_DURATION_S *
            COMPACT_BORDER_RADIUS_DELAY_FRACTION,
        duration:
            QUERY_PANEL_MOTION_DURATION_S *
            COMPACT_BORDER_RADIUS_DURATION_FRACTION,
        ease: BORDER_RADIUS_EASE,
    };
}

export function compactActionsEnterTransition(
    prefersReducedMotion: boolean | null,
): Transition {
    if (prefersReducedMotion) {
        return { duration: 0 };
    }
    return {
        delay: QUERY_PANEL_MOTION_DURATION_S,
        duration: QUERY_PANEL_MOTION_DURATION_S * 2,
        ease: QUERY_PANEL_EASE,
    };
}
